// extracted by mini-css-extract-plugin
module.exports = {"instructions":"_model__instructions__zniKw"};